import { resolveGatewayBaseUrl } from "../../runtime/loadSharedDashboardConfig";
import { resolveThisAppPublicUrl } from "../../utils/matchesAssignedApplicationOrigin";

function gatewayLoginUrl(): string {
  const fromEnv = (process.env.REACT_APP_LOGIN_URL ?? "").trim();
  if (fromEnv) return fromEnv;
  return `${resolveGatewayBaseUrl() || "http://localhost:4702"}/login`;
}

export function readThisAppLoginContext(): {
  url: string;
  name: string;
  keycloakClientId: string;
  applicationId: string;
} {
  const url = resolveThisAppPublicUrl();
  const name = (
    process.env.REACT_APP_APPLICATION_NAME ??
    process.env.REACT_APP_KEYCLOAK_CLIENT_ID ??
    "Bizeye"
  ).trim();
  const keycloakClientId = (process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? "").trim();
  const applicationId = (process.env.REACT_APP_APPLICATION_ID ?? "").trim();
  return { url, name, keycloakClientId, applicationId };
}

/** Gateway /login URL with explicit app context (survives cross-origin cookie issues). */
export function buildGatewayLoginUrlWithAppContext(options?: {
  forceLogin?: boolean;
}): string {
  const login = new URL(gatewayLoginUrl());
  const ctx = readThisAppLoginContext();
  login.searchParams.set("url", ctx.url);
  if (ctx.name) login.searchParams.set("name", ctx.name);
  if (ctx.keycloakClientId) {
    login.searchParams.set("keycloakClientId", ctx.keycloakClientId);
  }
  if (ctx.applicationId) {
    login.searchParams.set("applicationId", ctx.applicationId);
  }
  if (options?.forceLogin) {
    login.searchParams.set("prompt", "login");
  }
  return login.toString();
}
